import { Environment, init } from '@chegg/one-auth-sdk';

export { initSdk };

function initSdk() {
  const isProd = process.env.CHEGG_ENV == 'prod';
  let internationalDomain;
  if (typeof window !== 'undefined' && !window.location.origin.endsWith('com')) {
    internationalDomain = window.location.origin.split('.').pop();
  }
  init({
    env: isProd ? Environment.prod : Environment.test,
    clientId: 'CHGG',
    refreshOnStart: false,
    internationalDomain,
  });
}
